var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_4706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3816 2.96347C27.221 2.39068 26.9077 1.86849 26.473 1.44889C26.0382 1.02928 25.4971 0.72692 24.9036 0.5719C22.7308 0 13.9858 0 13.9858 0C13.9858 0 5.2404 0.0173111 3.06755 0.589211C2.47403 0.744241 1.93294 1.04662 1.49818 1.46624C1.06341 1.88586 0.750139 2.40808 0.589552 2.98089C-0.0676821 6.70679 -0.322635 12.3842 0.607599 15.9611C0.768202 16.5338 1.08148 17.056 1.51625 17.4756C1.95101 17.8952 2.49209 18.1976 3.0856 18.3526C5.25844 18.9245 14.0036 18.9245 14.0036 18.9245C14.0036 18.9245 22.7487 18.9245 24.9214 18.3526C25.515 18.1976 26.0561 17.8953 26.4909 17.4757C26.9256 17.0561 27.2389 16.5339 27.3996 15.9611C28.0928 12.2299 28.3064 6.55595 27.3816 2.96347Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2021 13.5175L18.4568 9.46222L11.2021 5.40698V13.5175Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_4706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.042d206c14ef2e0acfb59a8b7834e248.svg";
export { ForwardRef as ReactComponent };